// @ts-nocheck
import {
  Box,
  Button,
  Checkbox,
  Grid,
  Modal,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import styles from "./shiftcalendar.module.css";
import dayjs from "dayjs";
import { CustomIconButton } from "../../../../components/Custom/CustomIconButton";
import { Close } from "@mui/icons-material";
import { CustomDatePicker } from "../../../../components/Custom/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  checkForHoldDownAction,
  createPrebookingAction,
} from "../../../../store/actions/event/prebook";
import { alertDialogAciton } from "../../../../store/actions/auth";
import LoadingOverlay from "../../../../components/Custom/LoadingOverlay";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import { generateContractorList } from "../../../pre-book/_components/NewPreBook";

// NOTE: style for modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  minWidth: "780px",
  zIndex: 9,

  "@media (max-width: 780px)": {
    minWidth: "400px",
  },
};

export function generateDateTable(data) {
  if (!data) return null;

  const border = getCssVariableHandler({ variableName: "--primary-pink-hex" });

  let html = "";

  Object.entries(data || {}).forEach(([key, value]) => {
    if (value?.dates?.length) {
      html += `
            <h3 style="color: white; text-align: left; margin-bottom: 10px;">${value?.message ?? "No Title"}</h3>
            <table style="border-collapse: collapse; width: 100%; text-align: center; color: white; margin-bottom: 20px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Sl. No.</th>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Date</th>
                    </tr>
                </thead>
                <tbody>
        `;

      value?.dates?.forEach((date, index) => {
        html += `
                <tr>
                    <td style="border: 1px solid ${border}; padding: 5px;">${index + 1}</td>
                    <td style="border: 1px solid ${border}; padding: 5px;">${date ?? "N/A"}</td>
                </tr>
            `;
      });

      html += `</tbody></table>`;
    }
  });

  return html || null;
}

export const HoldDownShift = ({ open, handleClose, onUpdate }) => {
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.auth);
  const { addLoading } = useSelector((state) => state?.prebookContractors);

  const validationSchema = Yup.object({
    comment: Yup.string()
      .max(400, "Comment should be at most 400 characters!")
      .required("Comment is required!"),
    selectedDates: Yup.array()
      .of(Yup.string())
      .min(1, "At least one date should be selected"),
    startDate: Yup.string()
      .nullable()
      .trim()
      .when("selectDateRange", {
        is: true,
        then: (schema) => schema.required("Start date is required!"),
      })
      .test(
        "time-should-be-greater-than-today",
        "Start date cannot be a past date!",
        function (value) {
          return !value || !dayjs(value).isBefore(dayjs(), "day");
        },
      ),
    endDate: Yup.string()
      .nullable()
      .trim()
      .when("selectDateRange", {
        is: true,
        then: (schema) => schema.required("End date is required!"),
      })
      .test(
        "end-date-should-be-greater-than-start-date",
        "End date can not be before start date!",
        function () {
          return (
            !this.parent.endDate ||
            !dayjs(this.parent.endDate).isBefore(this.parent.startDate, "day")
          );
        },
      ),
    selectDateRange: Yup.bool(),
  });

  const formik = useFormik({
    initialValues: {
      selectedDates: [],
      selectDateRange: false,
      startDate: null,
      endDate: null,
      comment: "",
    },
    validationSchema,
    onSubmit: (values) => {
      let contractorData = [];
      values?.selectedDates?.forEach((dt) => {
        contractorData?.push({
          contractorId: userId,
          date: dt,
        });
      });

      // api call
      function holddownApiCall() {
        dispatch(
          createPrebookingAction({
            payload: {
              data: {
                contractorData,
                comment: values?.comment,
                holdDownShift: "holdDown",
              },
            },
            successCallback: (data) => {
              handleCleanDataAndClose();
              if (onUpdate) onUpdate();
              if (
                data?.duplicateArray?.contractors?.length > 0 ||
                data?.duplicateHoldDownArray?.contractors?.length > 0
              ) {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: `${data?.duplicateArray ? generateContractorList(data?.duplicateArray) : ""} ${data?.duplicateArray ? "</br>" : ""} ${data?.duplicateHoldDownArray ? generateContractorList(data?.duplicateHoldDownArray) : ""}`,
                  }),
                );
              } else {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: data?.message ?? "Prebooking successful!",
                  }),
                );
              }
            },
            failureCallback: (msg) => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Error",
                  message: msg ?? "Shift holding unsuccessful!",
                }),
              );
            },
          }),
        );
      }

      // check for holddown api call
      dispatch(
        checkForHoldDownAction({
          payload: {
            data: {
              contractorData,
              comment: values?.comment,
              holdDownShift: "holdDown",
            },
          },
          successCallback: (response) => {
            const errDates =
              (response?.bookedDates?.dates?.length || 0) +
              (response?.scheduledDates?.dates?.length || 0);
            const isBothSame = errDates === values?.selectedDates?.length;
            if (response?.bookedDates || response?.scheduledDates) {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: isBothSame ? "Error" : "Warning",
                  message: `You won't be able to add these days to your hold down shift. <br />${generateDateTable(response)}`,
                  onOk: isBothSame ? null : holddownApiCall,
                  okLabel: isBothSame ? null : "Proceed Others",
                }),
              );
            } else {
              holddownApiCall();
            }
          },
          failureCallback: (message) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: message ?? "Shift holding unsuccessful!",
              }),
            );
          },
        }),
      );
    },
  });

  const {
    values,
    setFieldValue,
    errors,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
  } = formik;

  const getDefaultClassName = getDefaultClassNames();
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  function onMultiDateSelect(e) {
    setFieldValue(
      "selectedDates",
      e?.map((d) => dayjs(d)?.format("YYYY-MM-DD")),
    );
  }

  function checkBoxClickHandler(e) {
    setFieldValue("selectDateRange", e?.target?.checked);
  }

  function deleteCurrentDateHandler(date) {
    const currDate = dayjs(date)?.format("YYYY-MM-DD");
    setFieldValue(
      "selectedDates",
      values.selectedDates?.filter(
        (dt) => dayjs(dt).format("YYYY-MM-DD") !== currDate,
      ),
    );
  }

  useEffect(() => {
    if (
      values?.startDate &&
      values?.endDate &&
      !errors?.startDate &&
      !errors?.endDate
    ) {
      const dates = [];
      let currDate = dayjs(values.startDate);
      const lastDate = dayjs(values.endDate);

      while (
        currDate.isBefore(lastDate, "day") ||
        currDate.isSame(lastDate, "day")
      ) {
        dates.push(currDate.format("YYYY-MM-DD"));
        currDate = currDate.add(1, "day");
      }

      setFieldValue("selectedDates", dates);
    }
  }, [
    values?.startDate,
    values?.endDate,
    errors?.startDate,
    errors?.endDate,
    setFieldValue,
  ]);

  function handleCleanDataAndClose() {
    formik.resetForm();
    handleClose();
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Modal open={open} onClose={handleCleanDataAndClose}>
        <Box
          sx={{
            ...style,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          {addLoading ? <LoadingOverlay open={true} /> : null}
          <Box className={styles.headingContainer}>
            <Typography className={styles.heading}>Hold Down Shift</Typography>
          </Box>
          <Box className={styles["calendar-parent"]}>
            <DayPicker
              mode="multiple"
              disabled={{
                before: new Date(),
              }}
              classNames={{
                month: `${getDefaultClassName.month} ${styles.month}`,
                selected: `${getDefaultClassName.selected} ${styles.selected}`,
                chevron: `${getDefaultClassName.chevron} ${styles.chevron}`,
              }}
              required={true}
              selected={values?.selectedDates?.map((date) =>
                dayjs(date).toDate(),
              )}
              onSelect={onMultiDateSelect}
            />
            {/* NOTE: at right there we'll be the selected dates */}
            <Box
              sx={{ maxHeight: "385px", overflowY: "auto" }}
              className="custom-scroll-bar"
            >
              {values?.selectedDates?.length > 0 && (
                <Box className={styles["selected-dates-container"]}>
                  <Typography fontWeight={600}>Selected Dates</Typography>
                  <Typography></Typography>
                  {values?.selectedDates?.map((date, i) => {
                    const dateString = dayjs(date).format("ddd MM/DD/YYYY");
                    return (
                      <Box className={styles["one-date"]} key={i}>
                        <Typography className={"no-wrap"}>
                          {dateString}
                        </Typography>
                        <CustomIconButton
                          onClick={() => deleteCurrentDateHandler(date)}
                        >
                          <Close
                            sx={{
                              fontSize: "1rem",
                            }}
                          />
                        </CustomIconButton>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          </Box>

          {/* NOTE: after it will be checkbox "select a date range" */}
          <Box sx={{ px: "16px", width: "100%" }}>
            <Box className={styles["bottom-container"]}>
              <Box className={styles["date-selector-container"]}>
                <Checkbox
                  sx={{
                    padding: "0",
                    color: "white",
                  }}
                  checked={values?.selectDateRange}
                  onChange={checkBoxClickHandler}
                />
                <Typography>Select date range</Typography>
              </Box>
            </Box>

            {values?.selectDateRange && (
              <Grid
                container
                sx={{ pr: "2.5rem", marginTop: "1rem", gap: "1rem" }}
              >
                <Grid item xs={12} md={5}>
                  <Typography>Start Date:</Typography>
                  <CustomDatePicker
                    disablePast
                    fullWidth
                    onBlur={handleBlur}
                    onChange={(date) => {
                      setFieldValue("startDate", date?.format("YYYY-MM-DD"));
                    }}
                    sx={{
                      "& > .MuiInputBase-root": {
                        "& > .MuiInputBase-input": isMediumScreen
                          ? {
                              paddingLeft: "0.25rem",
                              paddingRight: "0.25rem",
                            }
                          : null,
                        border: "none !important",
                        padding: "0 0.5rem",
                      },
                      "@media (max-width: 780px)": {
                        maxWidth: "15rem",
                      },
                    }}
                    slotProps={{
                      textField: { placeholder: "Start date" },
                      actionBar: {
                        actions: ["clear"],
                      },
                    }}
                    // format={values?.startDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                  />
                  {errors?.startDate && touched.startDate && (
                    <Typography color="error">{errors?.startDate}</Typography>
                  )}
                </Grid>

                <Grid item xs={12} md={5}>
                  <Typography>End Date:</Typography>
                  <CustomDatePicker
                    disablePast
                    onBlur={handleBlur}
                    onChange={(date) => {
                      setFieldValue("endDate", date?.format("YYYY-MM-DD"));
                    }}
                    fullWidth
                    sx={{
                      "& > .MuiInputBase-root": {
                        "& > .MuiInputBase-input": isMediumScreen
                          ? {
                              paddingLeft: "0.25rem",
                              paddingRight: "0.25rem",
                            }
                          : null,
                        border: "none !important",
                        padding: "0 0.5rem",
                        "@media (max-width: 780px)": {
                          maxWidth: "15rem",
                        },
                      },
                    }}
                    slotProps={{
                      textField: { placeholder: "Start date" },
                      actionBar: {
                        actions: ["clear"],
                      },
                    }}
                    // format={values?.endDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                  />
                  {errors?.endDate && touched.endDate && (
                    <Typography color="error">{errors?.endDate}</Typography>
                  )}
                </Grid>
              </Grid>
            )}
          </Box>

          {/* NOTE: and after that a comment text box */}
          <Box className={styles["comment-container"]}>
            <Typography>Comment:</Typography>
            <TextField
              sx={{
                color: "white",
                "& fieldset": {
                  borderColor: "white !important",
                  borderRadius: "8px",
                },
              }}
              InputProps={{
                style: {
                  color: "white",
                },
              }}
              fullWidth
              name="comment"
              rows={4}
              multiline
              onBlur={handleBlur}
              value={values?.comment}
              onChange={handleChange}
            />
            {errors?.comment && touched.comment && (
              <Typography color="error">{errors?.comment}</Typography>
            )}
          </Box>

          {/* NOTE: button to submit */}
          <Box className="bottom-btn-box">
            <Button className="btn-pink" onClick={handleSubmit}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </LocalizationProvider>
  );
};

HoldDownShift.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onUpdate: PropTypes.func,
};